/**
 * @generated SignedSource<<ac2af7f8f3671e457dd2b67eec38d40d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PassengerTableRow_passenger$data = {
  readonly ageOnReturn: number | null;
  readonly dob: string | null;
  readonly fullName: string | null;
  readonly roomPrice: number | null;
  readonly " $fragmentType": "PassengerTableRow_passenger";
};
export type PassengerTableRow_passenger$key = {
  readonly " $data"?: PassengerTableRow_passenger$data;
  readonly " $fragmentSpreads": FragmentRefs<"PassengerTableRow_passenger">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PassengerTableRow_passenger",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fullName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dob",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ageOnReturn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "roomPrice",
      "storageKey": null
    }
  ],
  "type": "Passenger",
  "abstractKey": null
};

(node as any).hash = "0332ce6dbc4f971b81cd5ac05930ab59";

export default node;
